<template>
  <div :id="echarts" ref="scatterChart" class="container" />
</template>

<script>
import * as echarts from "echarts";
import { EleResize } from "@/utils/eleResize";

export default {
  name: "scatterChart",
  props: {
    // 接收父组件传递过来的信息
    PieData: {
      type: Array,
      default: () => [],
    },
    xData: {
      type: Array,
      default: () => [],
    },
    yData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colors: {
        0: "#347FFF",
        1: "#E04848",
        2: "#E5C446",
        3: "#969696",
        4: "#2FD0FF",
        5: "#26E9BE",
        6: "#E07248",
      },
    };
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 100000;
    },
  },
  mounted: function () {
    const vm = this;
    vm.$nextTick(() => {
      vm.drawChart();
    });
  },
  created: () => {},
  methods: {
    drawChart() {
      var myChart = echarts.init(document.getElementById(this.echarts));
      var xDatas = [
        "0",
        "小于400",
        "400",
        "450",
        "500",
        "550",
        "600",
        "650",
        "700",
        "750",
        "800",
        "大于800",
        "",
      ];
      var yData = this.yData;
      var data = this.xData;  
      var that = this;

      var option = {
        grid: {
          //方法 2
          x: 0,
          y: 10,
          x2: 15,
          y2: 10,
          containLabel: true,
        },
        tooltip: {
          position: "top",
          formatter: function (params) {
            return (
              (params.value[0] < 400 ? "小于400" : params.value[0]) +
              "大小的" +
              yData[params.value[1]] +
              "井盖有" +
              params.value[2]
            );
          },
        },

        xAxis: {
          type: "value",
          data: xDatas,
          min: 300,
          max: 800,
          splitNumber: 12,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#182930",
              type: "dashed",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            interval: "auto",
            margin: 8,
            formatter: function (value, index) {
              if (value < 400 && value != 300) {
                return "<400";
              } else if (value == 300) {
                return "0";
              } else if (value > 800) {
                return ">800";
              } else {
                return value;
              }
            },
          },
        },
        yAxis: {
          type: "category",
          data: yData,
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              textAlign: "left",
            },
          },
        },
        series: [
          {
            type: "scatter",
            symbolSize: function (val) {
              if (val[2] < 30) {
                return val[2] * 1;
              } else {
                return (val[2] > 400 ? 400 : val[2]) * 0.2;
              }
            },
            data: data,
            itemStyle: {
              normal: {
                color: function (val) {
                  return that.colors[val.value[1]];
                },
              },
            },
            animationDelay: function (idx) {
              return idx * 5;
            },
          },
        ],
      };
      option && myChart.setOption(option);
      const listener = function () {
        myChart.resize();
      };
      EleResize.on(document.getElementById(this.echarts), listener);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
